var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvalid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "21px",
    viewBox: "0 0 25 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/invalid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/invalid",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/InValid",
    transform: "translate(5.000000, 3.000000)",
    fill: "#B7844D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,15 C11.64195,15 15,11.64195 15,7.5 C15,3.35805 11.64195,0 7.5,0 C3.35805,0 0,3.35805 0,7.5 C0,11.64195 3.35805,15 7.5,15 Z M7.5,13.63653 C10.8891,13.63653 13.6365,10.88913 13.6365,7.50003 C13.6365,4.11093 10.8891,1.36353 7.5,1.36353 C4.1109,1.36353 1.3635,4.11093 1.3635,7.50003 C1.3635,10.88913 4.1109,13.63653 7.5,13.63653 Z M6.817965,4.09098 L8.182035,4.09098 L8.182035,8.86338 L6.817965,8.86338 L6.817965,4.09098 Z M6.817965,9.54543 L8.182035,9.54543 L8.182035,10.9089 L6.817965,10.9089 L6.817965,9.54543 Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalid);
export default __webpack_public_path__ + "static/media/invalid.c8bad927742857929f298dc655934d4f.svg";
export { ForwardRef as ReactComponent };